var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bio',{attrs:{"initial":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }